<template>
  <div>
    <div class="el-message-box__wrapper" style="z-index: 2000">
      <div class="el-message-box el-message-box--center">
        <div class="el-message-box__header">
          <div class="el-message-box__title">
            <span>授权状态</span>
          </div>
        </div>
        <div class="el-message-box__content">
          <div class="el-message-box__container">
            <div class="el-message-box__message">
              <el-form :model="form" :rules="rules" ref="form">
                <el-form-item label="激活状态">
                  <span class="color-success" style="line-height: 40px" v-if="isActive">已激活</span>
                  <span class="color-warning" style="line-height: 40px" v-else-if="!isActive && expireAt">已到期</span>
                  <span class="color-danger" style="line-height: 40px" v-else>未激活</span>
                </el-form-item>
                <el-form-item label="到期时间" v-if="expireAt">
                  <span :class="{'color-danger': !isActive}" style="line-height: 40px">{{expireAt}}</span>
                </el-form-item>
                <el-form-item label="激活码" prop="uuid">
                  <el-input v-model="form.uuid" placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"></el-input>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
        <div class="el-message-box__btns">
          <el-button @click="$router.go(-1)" v-if="isActive">返回</el-button>
          <el-button type="primary" @click="confirm">激活</el-button>
        </div>
      </div>
    </div>
    <div class="v-modal" style="z-index: 1998"></div>
  </div>
</template>

<script>
  import {inputEmpty,checkUuid} from "@utils/validate"
  export default {
    name: "index",
    data() {
      return {
        isActive: this.$store.state.activeStatus,
        expireAt: this.$store.state.activeExpireAt,
        form: {
          uuid: ""
        },
        rules: {
          uuid: [inputEmpty("激活码"),checkUuid()]
        }
      }
    },
    methods: {
      confirm() {
        this.$refs['form'].validate(async isOk => {
          if (isOk) {
            let res = await this.$Http.activeLicense({...this.form});
            if (res) {
              this.$store.commit("setActiveStatus", {status: "", expire_at: ""});
              this.msgSuccess("激活成功");
              this.$router.push("/login").catch();
            }
          }
        });
      }
    }
  }
</script>

<style scoped>

</style>
